import { API } from 'api';
import { useQuery } from '@tanstack/react-query';
import { apiBasePath, apiName } from '../../assets';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

export type Discount = {
  id: number;
  amount: number;
  discount_code: string;
  mainaccount_id: string;
  used_order_id?: string;
  created_at: string;
};

type DiscountsResponse = {
  result: Discount[];
};

const fetchDiscounts = async (): Promise<Discount[]> => {
  const response: DiscountsResponse = await API.get(
    apiName,
    `${apiBasePath}/discounts`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.ACCOUNT,
        domain: DOMAINS.DISCOUNTS,
        importance: IMPORTANCE.HIGH,
      },
      context: {},
    },
  );

  return response.result;
};

const useDiscounts = () => {
  return useQuery({
    queryKey: ['discounts'],
    queryFn: fetchDiscounts,
  });
};

export default useDiscounts;
